import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-670175b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animate widget-container" }
const _hoisted_2 = {
  key: 0,
  class: "is-auth"
}
const _hoisted_3 = { style: {"display":"flex","justify-self":"right","overflow":"visible"} }
const _hoisted_4 = { class: "notification" }
const _hoisted_5 = {
  key: 0,
  class: "alert-notification"
}
const _hoisted_6 = { style: {"display":"flex","justify-self":"right","overflow":"visible"} }
const _hoisted_7 = {
  class: "notification",
  style: {"margin-left":"5px"}
}
const _hoisted_8 = {
  key: 0,
  class: "alert-notification"
}
const _hoisted_9 = { style: {"width":"24px","height":"24px","display":"flex","justify-self":"right","overflow":"hidden","margin-left":"15px","margin-right":"0px"} }
const _hoisted_10 = { style: {"height":"24px","display":"flex","justify-self":"right","overflow":"hidden","margin-left":"10px","margin-right":"10px"} }
const _hoisted_11 = { style: {"text-decoration":"none !important","text-decoration-color":"rgba(0,0,0,0)"} }
const _hoisted_12 = {
  key: 0,
  class: "animate context-menu"
}
const _hoisted_13 = { class: "search-form" }
const _hoisted_14 = { class: "friend-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  class: "profile"
}
const _hoisted_18 = { style: {"font-size":"12px"} }
const _hoisted_19 = { style: {"position":"absolute"} }

import { useAuth } from '@/store/useAuth'
import router from '@/router'
import AuthBtn from '../buttons/AuthBtn.vue'
import { ref, onMounted, onUnmounted } from 'vue'
import useWindowWidth from '@/composables/useWindowWidth'
import { useConversations } from '@/store/useConversations'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import FriendshipService from '@/services/FriendshipService'
import ConversationNotification from './ConversationNotification.vue'
import ProfileImage from '@/components/widgets/ProfileImage.vue'
import ReputationCard from './ReputationCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoWidget',
  setup(__props) {

const search = ref('')
const store = useAuth()
const showContextMenu = ref(false)
const { windowWidth } = useWindowWidth()
const storeConversations = useConversations()
const toast = useToast()
const friendshipRequests = ref([])
const service = new FriendshipService()
const friends = ref([])
const filteredFriends = ref([])
const allUnreads = ref(0)
const intervalId = window.setInterval(async () => {
    if (!store.token) {
        return
    }
    friendshipRequests.value = await service.listPendingRequests(store.token)
    friends.value = await service.listUserFriends(store.token)
    allUnreads.value = await service.getAllUnreadMessagesSentToYou(store.token)
    filteredFriends.value = friends.value
}, 10000)

onMounted(async () => {
    if (!store.token) {
        return
    }
    friendshipRequests.value = await service.listPendingRequests(store.token)
    friends.value = await service.listUserFriends(store.token)
    allUnreads.value = await service.getAllUnreadMessagesSentToYou(store.token)
    filteredFriends.value = friends.value
})


onUnmounted(() => {
    clearInterval(intervalId);
})

const handleSearch = () => {
    filteredFriends.value = friends.value.filter(item => item.name.toLowerCase().includes(search.value.toLowerCase()))
}


const toggleMenu = () => {
    if (windowWidth.value < 900) {
        return;
    }
    showContextMenu.value = !showContextMenu.value
}

const handleLogout = () => {
    store.logout()
    router.push({ name: 'auth' })
}

const showConversation = async (id: number) => {
    if (!store.token) {
        return
    }
    const success = await storeConversations.addConversation(store.token, id)
    if (!success) {
        toast.showToast("No puedes abrir más pop-ups de conversación simultáneos. Visita la sección de mensajería para acceder a todas las capacidades.", Toast.WARNING)
        setTimeout(function () { toast.hideToast() }, 4000);
    }
    toggleMenu()
}


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(store).token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_RouterLink, { to: { name: 'friend-request' } }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (friendshipRequests.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(friendshipRequests.value.length), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_icon, {
                      name: "fa-user-friends",
                      scale: "1.2",
                      style: {"margin-right":"5px"}
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (allUnreads.value > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(allUnreads.value), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_icon, {
                  name: "ri-message-2-fill",
                  onClick: toggleMenu,
                  style: {"cursor":"pointer"},
                  scale: "1.2"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(ProfileImage)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ReputationCard)
            ]),
            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(store).email), 1),
            _createVNode(_component_v_icon, {
              name: "la-power-off-solid",
              class: "logout-btn",
              hover: "true",
              animation: "wrench",
              onClick: handleLogout
            })
          ]))
        : (_openBlock(), _createBlock(AuthBtn, { key: 1 }))
    ]),
    (showContextMenu.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createVNode(_component_RouterLink, {
            to: { name: 'messages' },
            style: {"text-decoration":"none","font-size":"12px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Ir a mensajería.")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: { name: 'friends' },
            style: {"text-decoration":"none","font-size":"12px","margin-left":"5px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Añadir amigos.")
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "close",
            onClick: toggleMenu
          }, [
            _createVNode(_component_v_icon, { name: "ri-close-circle-fill" })
          ]),
          _createElementVNode("form", _hoisted_13, [
            _createVNode(_component_v_icon, { name: "fa-filter" }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              placeholder: "Buscar amigo...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
              onKeyup: handleSearch
            }, null, 544), [
              [_vModelText, search.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredFriends.value, (friend) => {
              return (_openBlock(), _createElementBlock("div", {
                key: friend.id
              }, [
                _createElementVNode("div", {
                  class: "friend",
                  onClick: ($event: any) => (showConversation(friend.id))
                }, [
                  (friend.profile_picture_uri)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "profile",
                        src: friend.profile_picture_uri,
                        width: "28"
                      }, null, 8, _hoisted_16))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(friend.name.substring(0, 2)), 1)),
                  _createElementVNode("h5", _hoisted_18, _toDisplayString(friend.name), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(ConversationNotification, {
                      friendId: friend.id,
                      style: {"position":"relative","top":"0"}
                    }, null, 8, ["friendId"])
                  ])
                ], 8, _hoisted_15)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})